// Valid Filters
const filtersWithOptions = [
  'make',
  'model',
  'green_light',
  'yellow_light',
  'blue_light',
  'color',
  'body_type',
  'fuel_type',
  'dealership_type',
  'drivetrain',
  'transmission',
  'mobility',
  'acv_inspected',
  'region',
  'equipment_options',
  'trim',
  'autosell',
  'auction_type',
  'engine_cylinders',
];

const filtersWithMaxOnly = [
  'distance_from_zip',
];
const filtersWithMinAndMax = [
  'floor_price',
  'odometer',
  'year',
];

const filtersWithSliderInputs = [
  ...filtersWithMinAndMax,
  ...filtersWithMaxOnly,
];

const filtersInMoreOptions = [
  'body_type',
  'fuel_type',
  'transmission',
  'drivetrain',
  'equipment_options',
  'green_light',
  'yellow_light',
  'blue_light',
  'acv_inspected',
  'dealership_type',
  'color',
  'mobility',
];

const laneEventCategories = {
  PUBLIC: {
    key: 'digital',
    title: 'Events',
  },
  PRIVATE_SELLING_PUBLIC_BUYING: {
    key: 'featured',
    title: 'Featured Seller Events',
  },
  PRIVATE: {
    key: 'private',
    title: 'Private Events',
  },
};

const fixedLanes = {
  noReserve: {
    id: 'guaranteed_sale',
    displayName: 'No Reserve', // (Guaranteed Sale)
    lanePermissionType: 'PUBLIC',
    lane_schedule_type: 'PERPETUAL',
  },
};

/**
 * Uuid of the real Guaranteed Sale lane, configured per environment and empty
 * until the lane exists there. Once gsale_lane_tech_enabled is on and
 * lane-info-service returns the real lane, this is the id that `guaranteed_sale`
 * resolves to, so the deep links and saved searches still holding the hardcoded
 * row's id keep working.
 *
 * Read through a function rather than a constant so the value is resolved at
 * call time instead of being captured at module load.
 */
const getGsaleLaneId = () => import.meta.env.VITE_GSALE_LANE_ID || '';

const laneEventsToHideFromView = ['Scheduled Auctions', 'Scheduled Auction With Buy Now'];

const laneEventsToMaskDisplayName = [
  'Low Reserve Preview',
  'Scheduled Auctions',
  'Scheduled Auction With Buy Now',
];

// fallback for states and sort options
const statesAndSortOptions = {
  states: [
    {
      label: 'All', value: 'all', selected: true, sortOptions: [{ label: 'Ending Soonest', value: 'end_time' }],
    },
    {
      label: 'Coming Soon', value: 'coming_soon', selected: false, sortOptions: [{ label: 'Starting Soonest', value: 'end_time' }],
    },
    {
      label: 'Active', value: 'active', selected: false, sortOptions: [{ label: 'Ending Soonest', value: 'end_time' }],
    },
    {
      label: 'Make Offer', value: 'make_offer', selected: false, sortOptions: [{ label: 'Ending Soonest', value: 'end_time' }],
    },
    {
      label: 'Sold', value: 'sold', selected: false, sortOptions: [{ label: 'Recently Ended', value: 'end_time' }],
    },
  ],
};

export {
  filtersWithOptions,
  filtersWithMaxOnly,
  filtersWithMinAndMax,
  filtersWithSliderInputs,
  filtersInMoreOptions,
  laneEventCategories,
  fixedLanes,
  getGsaleLaneId,
  laneEventsToHideFromView,
  laneEventsToMaskDisplayName,
  statesAndSortOptions,
};
